export default function humanProductType (type: string) {
  return {
    'concrete_slab': 'Slab',
    'cast_in_anchor_channel': 'Channel',
    't_bolt': 'T-bolt',
  }[type]
}
